var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6125 12.7939L6.84808 16.7937C6.7868 16.8588 6.71283 16.9107 6.63073 16.9462C6.54863 16.9817 6.46014 17 6.37071 17C6.28127 17 6.19278 16.9817 6.11068 16.9462C6.02858 16.9107 5.95462 16.8588 5.89333 16.7937L2.12892 12.7939C1.84612 12.4933 2.05908 12 2.47191 12H10.2695C10.6823 12 10.8953 12.4933 10.6125 12.7939Z",
    fill: "#EB8021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6125 7.20615L6.84808 3.20632C6.7868 3.14118 6.71283 3.08927 6.63073 3.05379C6.54863 3.01831 6.46014 3 6.37071 3C6.28127 3 6.19278 3.01831 6.11068 3.05379C6.02858 3.08927 5.95462 3.14118 5.89333 3.20632L2.12892 7.20615C1.84612 7.50673 2.05908 8 2.47191 8H10.2695C10.6823 8 10.8953 7.50673 10.6125 7.20615Z",
    fill: "#EB8021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToggle);
export default __webpack_public_path__ + "static/media/arrow-toggle.415d473bad9bd3691ea80d8d12b6935a.svg";
export { ForwardRef as ReactComponent };